import API from 'services/api';

interface IPayload {
  checkout: string;
  price: number;
}

interface IReportReservationChangeResponse {
  success: boolean;
  message: string;
}

export const reportReservationChange = ({
  calculationId,
  payload,
}: {
  calculationId: string;
  payload: IPayload;
}): Promise<IReportReservationChangeResponse> =>
  API.post(
    `/api/accommodation/calculations/${calculationId}/booking/report-reservation-change`,
    payload,
  ).then(response => response?.data);
